var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._cLRe{margin-top:32px;position:relative}.tMNmo{font-size:26px;color:#31404c;margin-bottom:21px}._1mwcf{font-size:14px;color:#848a90;position:absolute;top:10px;right:0;padding-right:20px;background-image:url(" + escape(require("./ic_More.png")) + ");background-repeat:no-repeat;background-position:100%}._1mwcf:hover{background:url(" + escape(require("./ic_More_Hover.png")) + ") 100% no-repeat}._1D4fM{display:inline-block;vertical-align:top;font-size:0;margin-right:20px;-webkit-transition:.3s;-o-transition:.3s;transition:.3s}._1D4fM:hover{-webkit-box-shadow:0 10px 30px 0 rgba(0,0,0,.2);box-shadow:0 10px 30px 0 rgba(0,0,0,.2);-webkit-transform:translateY(-5px);-ms-transform:translateY(-5px);transform:translateY(-5px);-webkit-transform-origin:bottom;-ms-transform-origin:bottom;transform-origin:bottom}._2lKKn{display:inline-block;width:580px;height:272px;border-radius:4px}", ""]);

// exports
exports.locals = {
	"root": "_cLRe",
	"title": "tMNmo",
	"more": "_1mwcf",
	"headImgWrap": "_1D4fM",
	"headImg": "_2lKKn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/p_home/Section/index.css
// module id = 1232
// module chunks = 1